export default __webpack_public_path__ + "static/media/defaultNews.d56b8298.jpg";